<template>
  <div>
    <table class="payment-row-expand">
      <tbody>
        <!--

      TÄMÄ ON ENNAKKOLASKUN KOMPONENTTI

      -->

        <tr v-if="payment.maksuehtonro === '14PN' || payment.maksuehtonro === 'OPR'">
          <th>{{ $t("orders.payment_method") }}:</th>
          <td :data-cy="`${tunniste}-maksutapa`">{{ payment.maksutapa }}</td>
        </tr>
        <tr v-if="payment.rahoituslinkki">
          <th>{{ $t("orders.financing_link")}}:</th>
          <td data-cy="rahoituslinkki"><a :href="payment.rahoituslinkki" class="white--text" target="_blank">{{payment.rahoituslinkki}}</a></td>
        </tr>

        <!-- ENNAKKOLASKUA EI LUOTU TAI EI NÄYTETÄ -->
        <template v-if="!invoice || !invoice.naytalasku">
          <tr v-if="maksupostityyppi === 'Myymälä'">
            <td colspan="2" class="text-left" data-cy="myymalatext">
              {{ $t("orders.payment_type_myymala_text") }}
            </td>
          </tr>
          <template v-if="!!payment.ennakkomaksu">
            <!-- Laskun tietoja ei ole tai ei näytetä, mutta ennakkomaksulla on arvo, joten näytetään määrä ja infoteksti -->
            <tr>
              <th class="text-left">{{ $t("orders.advance_payment_amount") }}:</th>
              <td data-cy="ennakkomaksun-osuus">
                {{ $formatNumberTo2Decimals(payment.ennakkomaksu, $user.language) }}
                {{ payment.valuutta }}
              </td>
            </tr>
            <tr v-if="invoice && invoice.laskutettupvm">
              <td colspan="2" data-cy="ennakkomaksutext" class="text-left">
                {{ $t("orders.advance_payment_not_registered_info") }}
              </td>
            </tr>
          </template>
        </template>

        <!-- Ennakkolaskun tiedot näytetään -->
        <template v-else>
          <tr>
            <td class="text-left pt-6 text-uppercase caption" colspan="2">
              {{ $t("orders.advance_payment") }}:
            </td>
          </tr>
          <tr v-if="naytaEnnakkomaksuTeksti">
            <td colspan="2" data-cy="ennakkomaksutext" class="text-left">
              {{ $t("orders.advance_payment_not_registered_info") }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("orders.advance_invoice_number") }}:</th>
            <td :data-cy="`${tunniste}-laskunumero`">{{ invoice.laskunumero }}</td>
          </tr>
          <tr>
            <th class="text-left">{{ $t("orders.advance_payment_amount") }}:</th>
            <td data-cy="ennakkomaksun-osuus">
              {{ $formatNumberTo2Decimals(invoice.loppusumma, $user.language) }}
              {{ payment.valuutta }}
            </td>
          </tr>
          <tr v-if="ennakkomaksuaSuoritettu && !payment.ennakkomaksu">
            <th>{{ $t("orders.advance_payment_amount") }}:</th>
            <td data-cy="ennakkomaksun-osuus">
              {{ $formatNumberTo2Decimals(invoice.loppusumma, $user.language) }}
              {{ invoice.valuutta }}
            </td>
          </tr>
          <tr class="body-2 grey--text text--lighten-1">
            <th>{{ $t("orders.price_without_tax") }}:</th>
            <td data-cy="alviton">
              {{ $formatNumberTo2Decimals(invoice.veroton, $user.language) }}
              {{ invoice.valuutta }}
            </td>
          </tr>
          <tr class="body-2 grey--text text--lighten-1">
            <th>{{ $t("orders.tax_amount") }}:</th>
            <td data-cy="alv">
              {{ $formatNumberTo2Decimals(invoice.verosumma, $user.language) }}
              {{ invoice.valuutta }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("orders.due_date") }}:</th>
            <td data-cy="erapaiva">{{ $formatDateNoTime(invoice.erapvm) }}</td>
          </tr>

          <tr v-if="bankgiro">
            <th>{{ $t("orders.bankgiro") }}:</th>
            <td data-cy="bankgiro">{{ payment.bankgironumero }}</td>
          </tr>
          <template v-else>
            <tr>
              <th>{{ $t("orders.iban") }}:</th>
              <td data-cy="tilinumero">{{ payment.iban }}</td>
            </tr>
            <tr>
              <th>{{ $t("orders.bic") }}:</th>
              <td data-cy="bic">{{ payment.bic }}</td>
            </tr>
            <tr>
              <th>{{ $t("orders.reference_number") }}:</th>
              <td :data-cy="`${tunniste}-viite`">{{ invoice.viitenumero }}</td>
            </tr>
          </template>

          <tr v-if="invoice.laskutettupvm">
            <th>{{ $t("orders.advance_payment_created") }}:</th>
            <td data-cy="ennakko-laskutettupvm">
              {{ $formatDateNoTime(invoice.laskutettupvm) }}
            </td>
          </tr>

          <tr v-if="false">
            <!--<tr v-if="!!invoice.ennakkomaksettu || maksettu">-->
            <th>{{ $t("orders.advance_payment_registered") }}:</th>
            <td data-cy="ennakkomaksu-kirjattupvm">
              {{ $formatDateNoTime(invoice.maksupvm) }}
            </td>
          </tr>
          <tr v-if="!!invoice.maksupvm">
            <th>{{ $t("orders.price_with_tax_paid") }}:</th>
            <td>
              {{ $formatNumberTo2Decimals(invoice.ennakkomaksettu, $user.language) }}
              {{ invoice.valuutta }}
            </td>
          </tr>
          <tr v-if="!maksettu && !!invoice.ennakkomaksettu">
            <th>{{ $t("orders.price_after_partial_payment") }}:</th>
            <td data-cy="ennakkomaksua-jaljella">
              {{
                $formatNumberTo2Decimals(
                  invoice.loppusumma - invoice.ennakkomaksettu,
                  $user.language
                )
              }}
              {{ invoice.valuutta }}
            </td>
          </tr>
          <tr v-if="false">
            <!--<tr v-if="!invoice.maksupvm">-->
            <th>{{ $t("orders.advance_payment_registered") }}:</th>
            <td data-cy="ennakkomaksu-kirjattupvm">
              {{ $t("orders.advance_payment_not_registered") }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div
      class="mt-4"
      v-if="!bankgiro && invoice && invoice.viivakoodi && !invoice.maksupvm && invoice.naytalasku"
    >
      <v-btn
        @click="copyTextToClipboard(invoice.viivakoodi)"
        outlined
        color="white"
        block
        data-cy="viivakooditext"
      >
        <hb-icon v-if="!textCopied" left>mdi mdi-barcode</hb-icon>
        <v-fab-transition>
          <hb-icon v-if="textCopied" color="success" left>mdi mdi-check</hb-icon>
        </v-fab-transition>
        {{ $t("orders.copy_barcode") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoice: {
      type: Object,
      required: false,
    },
    payment: {
      type: Object,
      required: true,
    },
    debug: {
      type: String,
      default: "rip",
    },
  },
  name: "AdvancePaymentInvoiceItem",
  data() {
    return {
      textCopied: false,
    };
  },
  computed: {
    bankgiro() {
      return this.payment.maanro === "SWE" && !!this.payment.bankgiro;
    },
    naytaEnnakkomaksuTeksti() {
      return (
        !!this.payment.ennakkomaksu &&
        (!!this.payment.advancePaymentInvoice === false ||
          !this.payment.advancePaymentInvoice.maksupvm ||
          !this.maksettu)
      );
    },
    maksettu() {
      if (!this.invoice) return false;
      return !!this.invoice.maksupvm && this.invoice.loppusumma - this.invoice.ennakkomaksettu <= 1;
    },
    maksupostityyppi() {
      return this.payment.maksupostityyppi;
    },
    ennakkomaksuaSuoritettu() {
      if (!this.payment.advancePaymentInvoice) return false;
      return (
        !!this.invoice.ennakkomaksettu && this.invoice.ennakkomaksettu < this.invoice.loppusumma
      );
    },
    tunniste() {
      if (this.invoice && !this.invoice.paarivi) {
        return "ennakko";
      } else if (this.invoice && this.invoice.paarivi) {
        return "tehtaanlasku";
      } else if (this.payment.maksupostityyppi) {
        return this.payment.maksupostityyppi.toLowerCase();
      }
      return "tuntematon";
    },
  },
  methods: {
    copyTextToClipboard(text) {
      try {
        navigator.clipboard.writeText(text);
        this.textCopied = true;
        this.$showSuccessNotification(this.$t("orders.barcode_copied"));
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 410px) {
  td,
  th {
    padding: 2px;
    margin: 0;
    font-size: 14px;
  }
  table {
    width: 100%;
  }
}
</style>
